import Image from '@/components/image/NextImage';
import { useAnalytics } from '@/hooks/analytics';
import { useScenes } from '@/hooks/app/useScenes';
import { Scene, SELECTED_SCENE_ID_KEY } from '@/hooks/app/useSelectedScene';
import { formatResizedUrl } from '@/utils/app/formatResizedUrl';

import { BackgroundImage, ClickTarget, ContentOverlay, Title, Wrapper } from './styles';
import { SceneCardProps } from './types';

const SceneCard = ({ card, isSelected }: SceneCardProps) => {
	const { logEvent } = useAnalytics();
	const { setSelectedScene } = useScenes();

	const onClick = (scene: Scene): void => {
		logEvent({
			eventName: 'Scene Selection : Scene : Clicked',
			eventProps: {
				scene_id: scene.id,
				scene_title: scene.title,
			},
		});

		localStorage.setItem(SELECTED_SCENE_ID_KEY, scene.id);
		setSelectedScene(scene);
	};
	// These sizes were all derived from measuring the elements at our standard breakpoints and rounding up a bit
	const nextImageSizes =
		'(min-width: 320px) 240px, (min-width: 480px) 392px, (min-width: 1440px) 25vw, 100vw';

	return (
		<Wrapper isSelected={isSelected} data-testid="scene-card">
			<BackgroundImage>
				<Image
					alt=""
					style={{ objectFit: 'cover' }}
					src={formatResizedUrl(card.image.url, 1000, 1000)}
					fill
					sizes={nextImageSizes}
				/>
			</BackgroundImage>
			<ClickTarget
				onPress={() => onClick(card)}
				aria-label={`Scene: ${card?.title}`}
				aria-current={isSelected}
				tabIndex={isSelected ? -1 : 0}
			>
				{card?.title && (
					<ContentOverlay>
						<Title>{card?.title}</Title>
					</ContentOverlay>
				)}
			</ClickTarget>
		</Wrapper>
	);
};

export default SceneCard;
